import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const SuccessStoryCarousel = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const successStories = {
    en: [
      {
        id: 1,
        type: 'creator',
        name: "Sarah Al-Mahmoud",
        title: "Food Content Creator",
        location: "Baghdad, Iraq",
        image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop",
        videoThumbnail: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop",
        achievement: "Earned $15,000+ in 6 months",
        story: `Started with 2K followers, now collaborating with major food brands across the region. CreatorBridge helped me turn my passion for traditional Iraqi cuisine into a sustainable career.`,
        metrics: {
          followers: "45K+",
          campaigns: "28",
          earnings: "$15,247"
        },
        quote: "CreatorBridge transformed my hobby into my dream career"
      },
      {
        id: 2,
        type: 'brand',
        name: "TechVision Solutions",
        title: "Technology Company",
        location: "Dubai, UAE",
        image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=400&fit=crop",
        videoThumbnail: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&h=400&fit=crop",
        achievement: "300% ROI increase",
        story: `Struggled to connect with regional audiences until we found authentic creators through CreatorBridge. Our campaigns now generate genuine engagement and measurable results.`,
        metrics: {
          reach: "2.5M+",
          engagement: "8.5%",
          roi: "300%"
        },
        quote: "Authentic creators delivered results we never achieved before"
      },
      {
        id: 3,
        type: 'creator',
        name: "Ahmed Hassan",
        title: "Tech Reviewer",
        location: "Cairo, Egypt",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
        videoThumbnail: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=600&h=400&fit=crop",
        achievement: "Built tech review empire",
        story: `From reviewing gadgets in my bedroom to partnering with global tech brands. CreatorBridge's tools and opportunities helped me scale my content and income professionally.`,
        metrics: {
          subscribers: "120K+",
          campaigns: "45",
          earnings: "$28,500"
        },
        quote: "Professional tools made all the difference in my growth"
      }
    ],
    ar: [
      {
        id: 1,
        type: 'creator',
        name: "سارة المحمود",
        title: "منشئة محتوى طعام",
        location: "بغداد، العراق",
        image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop",
        videoThumbnail: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop",
        achievement: "حققت أكثر من 15,000$ في 6 أشهر",
        story: `بدأت بـ 2000 متابع، والآن أتعاون مع علامات الطعام الكبرى في المنطقة. ساعدني CreatorBridge في تحويل شغفي بالمطبخ العراقي التقليدي إلى مهنة مستدامة.`,
        metrics: {
          followers: "45K+",
          campaigns: "28",
          earnings: "$15,247"
        },
        quote: "CreatorBridge حول هوايتي إلى مهنة أحلامي"
      },
      {
        id: 2,
        type: 'brand',
        name: "تك فيجن سوليوشنز",
        title: "شركة تكنولوجيا",
        location: "دبي، الإمارات",
        image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=400&fit=crop",
        videoThumbnail: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&h=400&fit=crop",
        achievement: "زيادة 300% في العائد على الاستثمار",
        story: `كافحنا للتواصل مع الجماهير الإقليمية حتى وجدنا مبدعين أصيلين من خلال CreatorBridge. حملاتنا الآن تحقق تفاعلاً حقيقياً ونتائج قابلة للقياس.`,
        metrics: {
          reach: "2.5M+",
          engagement: "8.5%",
          roi: "300%"
        },
        quote: "المبدعون الأصيلون حققوا نتائج لم نحققها من قبل"
      },
      {
        id: 3,
        type: 'creator',
        name: "أحمد حسن",
        title: "مراجع تقني",
        location: "القاهرة، مصر",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
        videoThumbnail: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=600&h=400&fit=crop",
        achievement: "بناء إمبراطورية مراجعة تقنية",
        story: `من مراجعة الأجهزة في غرفة نومي إلى الشراكة مع علامات التكنولوجيا العالمية. أدوات وفرص CreatorBridge ساعدتني في توسيع محتواي ودخلي بشكل احترافي.`,
        metrics: {
          subscribers: "120K+",
          campaigns: "45",
          earnings: "$28,500"
        },
        quote: "الأدوات الاحترافية صنعت كل الفرق في نموي"
      }
    ]
  };

  const carouselContent = {
    en: {
      title: "Success Stories",
      subtitle: "Real creators and brands achieving extraordinary results",
      watchStory: "Watch Story",
      viewProfile: "View Profile",
      nextStory: "Next Story",
      prevStory: "Previous Story"
    },
    ar: {
      title: "قصص النجاح",
      subtitle: "مبدعون وعلامات تجارية حقيقية تحقق نتائج استثنائية",
      watchStory: "مشاهدة القصة",
      viewProfile: "عرض الملف",
      nextStory: "القصة التالية",
      prevStory: "القصة السابقة"
    }
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % successStories?.[currentLanguage]?.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentLanguage]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % successStories?.[currentLanguage]?.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + successStories?.[currentLanguage]?.length) % successStories?.[currentLanguage]?.length);
  };

  const content = carouselContent?.[currentLanguage];
  const stories = successStories?.[currentLanguage];
  const currentStory = stories?.[currentSlide];

  return (
    <section className={`py-20 bg-muted ${currentLanguage === 'ar' ? 'rtl' : 'ltr'}`}>
      <div className="container mx-auto px-4">
        <div className={`text-center mb-16 ${currentLanguage === 'ar' ? 'text-right' : 'text-left'}`}>
          <h2 className="text-4xl font-bold text-foreground mb-4">
            {content?.title}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {content?.subtitle}
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <div className="card-elevated rounded-2xl overflow-hidden">
            <div className="grid lg:grid-cols-2 gap-0">
              {/* Story Content */}
              <div className="p-8 lg:p-12 space-y-6">
                <div className={`flex items-center space-x-4 gap-2`}>
                  <div className="relative">
                    <Image
                      src={currentStory?.image}
                      alt={currentStory?.name}
                      className="w-16 h-16 rounded-full object-cover"
                    />
                    <div className={`absolute -bottom-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center ${
                      currentStory?.type === 'creator' ? 'bg-accent' : 'bg-primary'
                    }`}>
                      <Icon 
                        name={currentStory?.type === 'creator' ? 'User' : 'Building'} 
                        size={12} 
                        color="white" 
                      />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-foreground">
                      {currentStory?.name}
                    </h3>
                    <p className="text-muted-foreground">{currentStory?.title}</p>
                    <p className="text-sm text-muted-foreground flex items-center space-x-1">
                      <Icon name="MapPin" size={12} />
                      <span>{currentStory?.location}</span>
                    </p>
                  </div>
                </div>

                <div className="bg-success/10 border border-success/20 rounded-lg p-4">
                  <p className="text-success font-semibold">
                    {currentStory?.achievement}
                  </p>
                </div>

                <blockquote className={`text-lg italic text-foreground ${currentLanguage === 'ar' ? 'text-right' : 'text-left'}`}>
                  "{currentStory?.quote}"
                </blockquote>

                <p className="text-muted-foreground leading-relaxed">
                  {currentStory?.story}
                </p>

                <div className="grid grid-cols-3 gap-4">
                  {Object.entries(currentStory?.metrics)?.map(([key, value]) => (
                    <div key={key} className={`text-center ${currentLanguage === 'ar' ? 'text-right' : 'text-left'}`}>
                      <div className="text-2xl font-bold text-primary">{value}</div>
                      <div className="text-xs text-muted-foreground capitalize">{key}</div>
                    </div>
                  ))}
                </div>

                <div className={`flex space-x-4 ${currentLanguage === 'ar' ? 'flex-row-reverse space-x-reverse' : ''}`}>
                  <Button 
                    variant="default" 
                    size="sm"
                    iconName="Play"
                    iconPosition={currentLanguage === 'ar' ? 'right' : 'left'}
                    onClick={() => setIsPlaying(!isPlaying)}
                  >
                    {content?.watchStory}
                  </Button>
                  <Link to="/community-showcase">
                    <Button 
                      variant="outline" 
                      size="sm"
                      iconName="ExternalLink"
                      iconPosition={currentLanguage === 'ar' ? 'right' : 'left'}
                    >
                      {content?.viewProfile}
                    </Button>
                  </Link>
                </div>
              </div>

              {/* Video/Image Preview */}
              <div className="relative bg-black">
                <Image
                  src={currentStory?.videoThumbnail}
                  alt={`${currentStory?.name} success story`}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/30" />
                
                {!isPlaying && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Button
                      variant="default"
                      size="lg"
                      className="bg-white/20 backdrop-blur-sm hover:bg-white/30 border-white/30"
                      iconName="Play"
                      onClick={() => setIsPlaying(true)}
                    >
                      <span className="sr-only">Play video</span>
                    </Button>
                  </div>
                )}

                {isPlaying && (
                  <div className="absolute inset-0 bg-black flex items-center justify-center">
                    <div className="text-white text-center">
                      <Icon name="Play" size={48} className="mx-auto mb-4" />
                      <p>Video would play here</p>
                      <Button
                        variant="ghost"
                        size="sm"
                        className="text-white mt-4"
                        onClick={() => setIsPlaying(false)}
                      >
                        Close
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Navigation Controls */}
          <div className="flex items-center justify-between mt-8">
            <Button
              variant="outline"
              size="sm"
              onClick={prevSlide}
              iconName="ChevronLeft"
              iconPosition="left"
            >
              {content?.prevStory}
            </Button>

            <div className="flex space-x-2">
              {stories?.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full transition-colors duration-200 ${
                    index === currentSlide ? 'bg-primary' : 'bg-border'
                  }`}
                />
              ))}
            </div>

            <Button
              variant="outline"
              size="sm"
              onClick={nextSlide}
              iconName="ChevronRight"
              iconPosition="right"
            >
              {content?.nextStory}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStoryCarousel;